<template>
  <div style="width:100%" class="event">
      <p>{{ $store.getters['getClientMeta'].name }}</p>
      <h3 class="line-title">Mesajlarım</h3>
      <form v-on:submit.prevent="filter" class="top-filter">
        <div class="buttons">
          <button  type="button" @click="form.status = 'waiting'" :class="form.status == 'waiting' ? 'active' : ''">Bekliyor</button>
          <button  type="button" @click="form.status = 'replied'" :class="form.status == 'replied' ? 'active' : ''">Cevaplandı</button>
          <button  type="button" @click="form.status = 'completed'" :class="form.status == 'completed' ? 'active' : ''">Tamamlandı</button>
        </div>
        <select v-model="form.department">
            <option :value="null">Seçiniz</option>
            <option value="finance">Finansal</option>
            <option value="ads">Reklam</option>
            <option value="coupon">Kupon</option>
            <option value="casino">Casino</option>
            <option value="suggestion">Öneri / Şikayet</option>
            <option value="other">Diğer</option>
        </select>
        <ButtonLoader class="primary" :loader="btnLoading" :text="'Filtrele'" >
          <template name="icon">
            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
          </template>
        </ButtonLoader>
        <button style="width:200px; margin-left:5px" @click="create" class="button secondary">Mesaj Oluştur</button>
      </form>
      <div class="user-content-inc table-panel">
        <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;' : ''" />
        <div class="panel" v-if="!loading">
            <div class="title">
                <div class="col id" :class="{ 'col-2' : !isMobile}" v-if="!isMobile">ID</div>
                <div class="col" :class="{ 'col-2' : !isMobile}">Durum</div>
                <div class="col" :class="{ 'col-3' : !isMobile}">Konu</div>
                <div class="col" :class="{ 'col-3' : !isMobile}">Departman</div>
                <div class="col" :class="{ 'col-2' : !isMobile}">Görüntüle</div>
            </div>
            <div class="content">
                <div class="table-col" v-if="!loading && !_.isEmpty(tickets)">
                    <div class="item"  v-for="(ticket,key) in tickets" :key="key">
                        <div class="col id" :class="{ 'col-2' : !isMobile}" v-if="!isMobile">#{{ ticket.ticket_id }}</div>
                        <div class="col" :class="{ 'col-2' : !isMobile}"><div v-if="isMobile">#{{ ticket.ticket_id }}</div> 
                          <strong>{{ $t(ticket.status_name) }}</strong></div>
                        <div class="col" :class="{ 'col-3' : !isMobile}">{{ ticket.subject }} </div>
                        <div class="col" :class="{ 'col-3' : !isMobile}"><strong>{{ $t(ticket.department_name) }}	</strong></div>
                        <div class="col" :class="{ 'col-2' : !isMobile}">
                          <button class="button secondary" @click="openDetail(ticket); $router.replace({ query: { ticket: parseInt(ticket.ticket_id) }})">Detaylar</button>
                        </div>
                    </div>
                </div>
                <div class="alert" v-show="!loading && _.isEmpty(tickets)">
                    Sonuç Bulunamadı
                </div>
            </div>
        </div>
      </div>
  </div>
</template> 
<style scoped>
  .mobile-create{
    height: 40px;
    font-weight: bold;
    margin: 5px 0 15px 0;
  }
</style>
<script>
  import Header from '../../Common/User/Header'
  import FilterPanel from '../../Common/User/FilterPanel'
  export default{
    props:['loading', 'tickets','btnLoading'],
    data(){
      return{
          form:{
            status: null,
            department: null
          },
          loader: false,
          mobileFilter: false,
      }
    },
    components:{
      FilterPanel,
      Header
    },
    watch:{
      mobileFilter(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    },
    created(){
    },
    methods:{
        openDetail(ticket){
          this.$emit('activeTicket', ticket);
        },
        create(){
          this.$emit('CreateTicket', true);
        },
        filter(){
          this.$parent.btnHomeLoading = true;
          this.mobileFilter = false;
          this.$parent.fetchData(this.form);
        },
        filter_open(){
          this.mobileFilter = true;
        },
    }
  }
</script>